import BaseClass from "../BaseClass.js";

export default class CheckboxGroup extends BaseClass {

    constructor(element) {
        super(element);

        this.memberName = null;

        this.init();
    }

    init() {
        let mySelf = this;

        let groupName = this.$element.data('group-name');
        if (groupName != undefined && $('input[data-group-element=' + groupName + ']').length) {
            this.memberName = groupName;
        }
        this.clickListener = function (event) {
            mySelf.setGroupState(event);
        }
        this.$element.on('click', this.clickListener);
    }

    setGroupState() {
        let status = this.$element.is(':checked');
        $('input[data-group-element=' + this.memberName + ']').prop('checked', status);
    }

    destroyListener() {
        this.$element.off('click', this.clickListener);
    }
}